import React from 'react';

import { T } from 'react-translator-component';

import { ChargePointGroupProps } from '../../../types/responses/ChargePointGroups';

export interface UsersInnerData {
  recharges?: number;
  consumption?: number;
  status?: string;
  user_pk?: number;
  user_name?: string;
  email?: string;
  ocpp_id_tag?: string;
}

const innerDataFormater = ({ ...rest }: ChargePointGroupProps) => {
  return rest;
};

const listFormater = (list: ChargePointGroupProps[]) => {
  let cardsList: any = [];
  let innerData: any = [];

  list !== undefined &&
    list.forEach((cpGroup) => {
      cardsList = [
        ...cardsList,
        [
          { value: cpGroup?.name, subValue: '', icon: <></>, size: '30%' },
          {
            value:
              (cpGroup?.address?.street &&
                `${cpGroup?.address?.street} ${
                  cpGroup?.address?.houseNumber ? ', ' + cpGroup?.address?.houseNumber : ''
                }
                ${cpGroup?.address?.city ? '- ' + cpGroup?.address?.city : ''} ${
                  cpGroup?.address?.state ? ',' + cpGroup?.address?.state : ''
                }`) ||
              T('Undefined'),
            subValue: '',
            icon: <></>,
            size: '50%',
          },
          { value: cpGroup?.externalId, subValue: '', icon: <></>, size: '20%' },
        ],
      ];

      innerData = [...innerData, innerDataFormater(cpGroup)];
    });

  return { cardsList, innerData };
};

export const combiningObjects = (list: ChargePointGroupProps[], header) => {
  return {
    header,
    ...listFormater(list),
  };
};
